import getDFPBlock from "../../utils/getDFPBlock";

/**
 * Use for placing advertising on Sport and education.
 * For other sub
 *
 * @param newsId
 * @param newsIndex: starts from 1
 */

export default function (newsId, newsIndex) {
    let wrapperId = 'adv' + newsId + 100;
    let advWrapper = document.getElementById(wrapperId);

    let advSecond = document.getElementById('adv' + newsId + 200);
    let advThird = document.getElementById('adv' + newsId + 300);

    if(advSecond !== null){
        advSecond.remove();
    }

    if(advThird !== null){
        advThird.remove();
    }

    if (newsIndex === 1) {
        if (advWrapper !== null && advWrapper.childNodes.length === 0) {
            advWrapper.remove();
        }

        return;
    }

    if (advWrapper !== null && advWrapper.childNodes.length === 0) {
        if (newsIndex >= 2) {
            if (window.innerWidth < 640) {
                getDFPBlock('/56301415/24tv_in_news_mobile_1_(2-5)', [[1, 1], [300, 250]], wrapperId, '300px');
            } else {
                getDFPBlock('/56301415/24tv_in_news_desktop_1_(2-5)', [[1, 1], [580, 400]], wrapperId, '580px');
            }
        }
    }
}